import { CardHeader, CardTitle } from "@/components/ui/card";
import FavoriteButton from "@/components/favorites/FavoriteButton";
import ShareSpotButton from "@/components/growth/ShareSpotButton";

interface SpotCardHeaderProps {
  address: string;
  spotId?: string;
}

const SpotCardHeader = ({ address, spotId }: SpotCardHeaderProps) => {
  return (
    <CardHeader className="flex flex-row items-start justify-between gap-2 space-y-0">
      <CardTitle className="text-xl flex-1">{address}</CardTitle>
      <div className="flex items-center gap-1">
        {spotId && <ShareSpotButton spotId={spotId} spotAddress={address} />}
        {spotId && <FavoriteButton spotId={spotId} />}
      </div>
    </CardHeader>
  );
};

export default SpotCardHeader;
